import { fetchJSON as fetchAPI } from './client';

export type SprintDashboard = {
  sprint_id: string; objectives: number; intelligence_modules: number;
  provider_interfaces: number; background_jobs: number; quality_gates: number;
  backend_apis: number; database_tables: number; generated_at: string;
};

export type SprintValidation = {
  valid: boolean; every_campaign_has_health_score: boolean; recommendations_from_dna: boolean;
  simulation_operational: boolean; version_control_functional: boolean; rollback_functional: boolean;
  experiments_auto_created: boolean; marketplace_dna_updated: boolean; attribution_operational: boolean;
  gaps?: string[];
};

export type Dev107Status = {
  sprint_id: string; objectives: number; intelligence_modules: number;
  advertising_growth_platform: boolean; production_ready: boolean; dna_integrated: boolean;
  attribution_operational: boolean; status: string;
};

const GOVERNANCE_BASE = import.meta.env.VITE_GOVERNANCE_API ?? '/api/v1/governance';
const fetchG = <T,>(path: string, init?: RequestInit) => fetchAPI<T>(`${GOVERNANCE_BASE}${path}`, init);

export const advertisingGrowthIntelligenceDev107Api = {
  dashboard: () => fetchG<SprintDashboard>('/dev107/dashboard'),
  objectives: () => fetchG<{ objectives: { key: string; name: string; category: string }[] }>('/dev107/objectives').then((r) => r.objectives),
  intelligenceModules: () => fetchG<{ modules: { key: string; name: string; category: string }[] }>('/dev107/intelligence-modules').then((r) => r.modules),
  providers: () => fetchG<{ providers: { key: string; name: string; interface: string }[] }>('/dev107/service-architecture').then((r) => r.providers),
  backgroundJobs: () => fetchG<{ jobs: { key: string; name: string; schedule?: string }[] }>('/dev107/background-jobs').then((r) => r.jobs),
  qualityGates: () => fetchG<{ gates: { key: string; name: string; blocking: boolean }[] }>('/dev107/quality-gates').then((r) => r.gates),
  validate: (attrs: Record<string, boolean>) =>
    fetchG<SprintValidation>('/dev107/validate', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attrs }) }),
  status: () => fetchG<Dev107Status>('/dev107/status'),
};
